import * as React from 'react';
import cx from 'classnames';
import styles from './ButtonGroup.m.sass';
export default function ButtonGroup(_ref) {
  var children = _ref.children,
    centered = _ref.centered;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root, centered && styles.centered)
  }, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.item
    }, child);
  }));
}
//# sourceMappingURL=index.js.map
